<template>
  <!-- content -->
  <div class="content">
    <detail-info @crumbsBack="crumbsBack" v-if="isShowDetail" />
    <div v-else>
      <div class="main" v-show="success">
        <span class="fastReg">审批中</span>

        <div class="name-content">
          <span class="approval">您的合作信息正在审批中，请耐心等待！</span>
          <el-button
            plain
            type="single-number"
            style="margin-top:-14px"
            @click="toDetail()"
            >查看详情</el-button
          >
        </div>
        <button class="agree" @click="goPage">去首页</button>
      </div>
      <div class="main" v-show="!success">
        <span class="fastReg">审批退回</span>
        <span class="approval" :title="companyName"
          >退回原因：{{ companyNamePer }}</span
        >
        <div calss="btnBox" style="display: flex ">
          <button class="agree update" @click="leaves">修改信息</button>
          <button class="agree goIndex" @click="goPage">去首页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import detailInfo from "../subcontractor/components/detail-info.vue";
export default {
  components: {
    detailInfo
  },
  data() {
    return {
      companyNamePer: "",
      success: null,
      companyName: "",
      supplierCode: "",
      isShowDetail: false
    };
  },
  mounted() {
    this.$eventBus.$on("last", res => {
      if (res) {
        if (res.companyName.length > 15) {
          this.companyNamePer = res.companyName.substring(0, 15) + "...";
        } else {
          this.companyNamePer = res.companyName;
        }
        this.companyName = res.companyName;
        this.success = res.success;
        this.supplierCode = res.supplierCode;
        if (res.supplierCode) {
          this.supplierCode = res.supplierCode;
        }
      }
      console.log(res);
      if (localStorage.getItem("reverseData")) {
        this.supplierCode = JSON.parse(
          localStorage.getItem("reverseData")
        ).supplierCode;
      }
    });
  },
  methods: {
    crumbsBack() {
      this.isShowDetail = false;
    },
    toDetail() {
      this.isShowDetail = true;
    },
    goPage() {
      this.$router.push("/");
    },
    leaves() {
      console.log(this.supplierCode);
      this.$eventBus.$emit("leaves", this.supplierCode);
      // console.log(1);
    }
  }
};
</script>

<style scoped lang="scss">
html,
body {
  font-family: Arial;
  background-color: #f5f5f9;
  padding: 0px;
  margin: 0px;
  -webkit-font-smoothing: antialiased; /*让字体更润滑*/
  -moz-osx-font-smoothing: grayscale; /*让字体更润滑*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*禁止链接高亮*/
  -webkit-touch-callout: none; /*禁止链接长按弹出选项*/
}
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
input,
button {
  border: 0 none;
  border-radius: 0px;
  outline: none;
}
.content {
  width: 100%;
  min-height: 325px !important;
  height: calc(100vh - 290px) !important;
  line-height: 0 !important;
  background: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.main {
  padding-top: 50px;
  width: 500px !important;
}
.approval {
  /* min-width: 500px; */
  height: 25px;
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(74, 74, 74, 1);
  line-height: 25px;
  display: block;
  text-align: left;
  margin-top: 20px;
  margin-bottom: 30px;
}
.agree {
  width: 500px;
  height: 40px;
  background: rgba(255, 20, 47, 1);
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  cursor: pointer;
}
.btnBox {
  flex-direction: row;
  justify-content: flex-start;
}
.update {
  width: 240px;
  height: 40px;
}
.goIndex {
  width: 240px;
  height: 40px;
  margin-left: 20px;
}
.fastReg {
  min-width: 60px;
  height: 25px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
  text-align: left;
  line-height: 25px;
  display: block;
}
.name-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/deep/ .el-button {
  background: #ffffff;
  border-color: #ff142f;
  span {
    color: #ff142f;
  }
  &:hover,
  &:active {
    border-color: #ff142f !important;
    background-color: #ffedef !important;
  }
  &:focus {
    border-color: #ff142f !important;
  }
}
</style>
